export var WAIT_TIME_BEFORE_SAVING = 300;
export var COPY_CHANGE_TEXT_TIME = 1500;
